import { request } from '@/renderer/utils/api';
import { IS_SERVER } from '@/renderer/utils/ssr';

export interface WallsPost {
  id: number;
  slug: string;
  title: string;
  body: string;
  excerpt: string | null;
  coverImage: string | null;
  author: string;
  status: string;
  publishedAt: string | null;
  tags: string[] | null;
  seoTitle: string | null;
  seoDescription: string | null;
}

export interface IndexData {
  posts: WallsPost[];
}

const abortInit = () =>
  typeof AbortSignal === 'undefined'
    ? {}
    : { signal: AbortSignal.timeout(IS_SERVER ? 2000 : 10000) };

export async function data(): Promise<IndexData> {
  try {
    const res = await request<{ data: WallsPost[] }>(
      { input: '/api/v1/posts?page[limit]=50', init: abortInit() },
      { skipRefresh: true, cache: { maxAge: 5 * 60 * 1000 } },
    );

    return { posts: res?.data ?? [] };
  } catch {
    return { posts: [] };
  }
}
